/**
 * Redirects the current page to the specified URL.
 * @param {string} url - The URL to navigate to.
 */
export const goToUrl = (url: string) => {
  window.location.href = url;
};
